import { HTMLAttributes } from 'react';
import { cn } from '@/utils';

export default function Container({ children, className }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'max-h-[100svh] w-screen bg-[#F8F8FF] p-3 pt-[max(calc(env(safe-area-inset-top)_/_2),_12px)] md:max-h-[95svh] md:min-h-[43.75rem] md:w-[48rem] md:rounded-[2rem] md:p-[4rem]',
        className,
      )}
    >
      {children}
    </div>
  );
}